import { appApis } from "../constants";
import HttpClient from "./http-client";

export const taskManagementApi = {
    getAssignees: `${appApis.getUsers}/assigness`,
    ccMembers: appApis.taskBaseApi,
    createTask: appApis.taskBaseApi,
    getTasks: appApis.taskBaseApi,
    getTaskById: appApis.taskBaseApi,
    updateTask: appApis.taskBaseApi,
    getTaskStatuses: `${appApis.taskBaseApi}/status`,
    createTaskComment: appApis.taskBaseApi,
    getDashboardData: `${appApis.taskBaseApi}/dashboard`,
}

export const updateTaskAction = (id, taskData) => new HttpClient().put(`${appApis.taskBaseApi}/${id}`, taskData)
